<template>
  <CardIcon
    v-if="shouldShowCard"
    icon="info"
    :iconBackground="false"
    type="informational"
  >
    <div :class="$style.cardContainer">
      <div :class="$style.mainContent">
        <slot />
      </div>
      <ButtonClose
        :class="$style.closeButton"
        data-test-id="AnnouncementCard__closeButton"
        @click="handleCloseButtonClick"
      />
    </div>
  </CardIcon>
</template>

<script>
import {
  ButtonClose,
  CardIcon,
} from '@jumpcloud/ui-components';
import LocalStorageConstants from 'client/util/Constants/LocalStorageConstants';
import LocalStorageService from 'client/util/LocalStorageService';

const {
  announcementCardState,
} = LocalStorageConstants;

export default {
  name: 'AnnouncementCard',

  components: {
    ButtonClose,
    CardIcon,
  },

  LocalStorageService,

  props: {
    localStorageKey: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      shouldShowCard: false,
    };
  },

  mounted() {
    const cardState = this.getCardState();
    this.shouldShowCard = !cardState[this.localStorageKey];
  },

  methods: {
    getCardState() {
      const { getItem } = this.$options.LocalStorageService;

      return JSON.parse(getItem(announcementCardState)) || {};
    },

    handleCloseButtonClick() {
      this.hideCard();
      this.$emit('close');
    },

    hideCard() {
      this.shouldShowCard = false;

      // Set local storage to say this has been viewed
      const cardState = this.getCardState();
      cardState[this.localStorageKey] = true;
      this.saveCardState(cardState);
    },

    saveCardState(value) {
      const { setItem } = this.$options.LocalStorageService;
      setItem(announcementCardState, JSON.stringify(value));
    },
  },
};
</script>

<style module scoped>
.cardContainer {
  display: flex;
}

.closeButton {
  flex-shrink: 0;
  margin-left: var(--jc-spacer-large);
}

.mainContent {
  flex-grow: 1;
  justify-content: space-between;
}
</style>
